import React from 'react';
import { theme } from '../styles/theme';

function Loader({ text = 'Caricamento in corso...' }) {
  return (
    <div style={styles.loadingContainer}>
      <div style={styles.spinner}></div>
      <p style={styles.loadingText}>{text}</p>
    </div>
  );
}

const styles = {
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
  spinner: {
    border: '4px solid rgba(0, 0, 0, 0.1)',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    borderLeftColor: theme.colors.brand,
    animation: 'spin 1s ease infinite',
  },
  loadingText: {
    marginTop: '10px',
    fontSize: '16px',
    color: theme.colors.text,
  },
};

export default Loader;
